var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7H13.5",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5L13.5 7L11.5 9",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6999 11.4902C10.802 12.4262 9.64454 13.0721 8.3765 13.3449C7.10846 13.6176 5.78781 13.5048 4.58441 13.0209C3.38102 12.537 2.34992 11.7041 1.62374 10.6294C0.897566 9.55467 0.509521 8.28729 0.509521 6.99024C0.509521 5.69319 0.897566 4.4258 1.62374 3.35109C2.34992 2.27638 3.38102 1.4435 4.58441 0.959578C5.78781 0.475657 7.10846 0.362828 8.3765 0.635603C9.64454 0.908379 10.802 1.55428 11.6999 2.49024",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTo);
export default __webpack_public_path__ + "static/media/to.6ecbf67a879a1cb72e58cbf68aed769a.svg";
export { ForwardRef as ReactComponent };